export default "__VITE_ASSET__DYIGgNtj__"